import React from "react";
import { useLocation } from "react-router-dom";

const CreateAccount = () => {
  const location = useLocation();
  return (
    <div className="col-12 col-lg-6 col-md-6 d-flex create-account-section align-items-center">
      <div className="content-wrapper align-content-center h-100">
        <span className="ageo-bold">New to MyHealthChecked?</span>
        <p className="mx-auto ageo-medium">
          Create an account to register your test, view results and track your progress.
        </p>
        <a
          className="btn btn-white w-100 fs-18"
          href={
            location?.search
              ? `/create-account/${location?.search}`
              : "/create-account"
          }
        >
          Create an account
        </a>
      </div>
    </div>
  );
};

export default CreateAccount;
